import { DEFAULT_COMPETITION_TYPE } from '@/common/constant/qz';
import { fetch } from '@/common/js/fetch';
import { serverCourseUrl,mathServerUrl } from "./api";


let userIdentityPromise = null;
let userIdentity = // TODO: 删除mock数据
// {
//   "userId": 1212,
//   "username": "xiannenglin",
//   "schoolName": "学军小学",
//   "schoolId": 1,
//   "grade": "1",
//   "idCardNo": "3706****",
//   "competitionType": "***",
//   "roles": ["TEACHER", 'STUDENT']
// }
null
export function getUser(competitionType=DEFAULT_COMPETITION_TYPE) {
  if (userIdentity) {
    return Promise.resolve(userIdentity);
  }
  if (userIdentityPromise) {
    return userIdentityPromise;
  }
  userIdentityPromise = fetch(`${serverCourseUrl}v1/user/competition/customized/identity/query?competitionType=${competitionType}`).then(res => {
    if (res && res.code === 200) {
      userIdentity = res.body.identity;
      return userIdentity;
    }
  }).finally(() => {
    userIdentityPromise = null;
  })
  return userIdentityPromise;
}

export function saveUser(info) {
  return fetch(`${serverCourseUrl}v1/user/competition/customized/identity/save`, {
    competitionType: DEFAULT_COMPETITION_TYPE,
    ...info,
  }, {
    method: 'POST',
  })
}

export function getUserInfo(competitionType=DEFAULT_COMPETITION_TYPE) {
  return fetch(`${serverCourseUrl}v1/user/competition/customized/identity/query?competitionType=${competitionType}`)
}
export function getCourseAuth(){
  return fetch(`${mathServerUrl}v1/user/login`)
}